"use client";
import type { Prisma } from "@-/prisma";
import type { AgencyLayoutTabCounts } from "@/components/agencies/AgencyLayout";
import type { agencyInclude } from "@/includes/agency";
import { createContext } from "react";

export type AgencyLayoutContext = {
  subagency: Prisma.AgencyGetPayload<{ include: typeof agencyInclude }>;
  hasSubAgencies: boolean;
  tabCounts: AgencyLayoutTabCounts;
};

const LayoutContext = createContext<AgencyLayoutContext>(null!);

export default LayoutContext;
